(() => {
  'use strict';

  const roots = document.querySelectorAll('[data-seq-blog-index]');
  if (!roots.length) return;

  roots.forEach(root => {
    const topicTrack = root.querySelector('[data-topic-track]');
    const topicButtons = root.querySelectorAll('[data-topic-scroll]');
    const mobileBooking = root.querySelector('[data-blog-mobile-booking]');
    const hero = root.querySelector('.seq-blog-index__hero');
    const reveals = Array.from(root.querySelectorAll('[data-blog-reveal]'));
    const topicalLinks = root.querySelectorAll('.seq-blog-index__hero-topics a[href^="#"]');

    if (topicTrack && topicButtons.length) {
      const updateTopicControls = () => {
        const maxScroll = Math.max(0, topicTrack.scrollWidth - topicTrack.clientWidth);
        topicButtons.forEach(button => {
          const direction = Number(button.dataset.topicScroll || 0);
          const disabled = direction < 0
            ? topicTrack.scrollLeft <= 4
            : topicTrack.scrollLeft >= maxScroll - 4;

          button.disabled = disabled;
          button.style.opacity = disabled ? '.35' : '1';
        });
      };

      topicButtons.forEach(button => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.topicScroll || 0);
          topicTrack.scrollBy({
            left: direction * Math.max(240, topicTrack.clientWidth * 0.72),
            behavior: 'smooth'
          });
        });
      });

      topicTrack.addEventListener('scroll', updateTopicControls, { passive: true });
      window.addEventListener('resize', updateTopicControls, { passive: true });
      updateTopicControls();

      const activeTopic = topicTrack.querySelector('.is-active');
      if (activeTopic) {
        window.requestAnimationFrame(() => {
          const trackRect = topicTrack.getBoundingClientRect();
          const activeRect = activeTopic.getBoundingClientRect();
          const maxScroll = Math.max(0, topicTrack.scrollWidth - topicTrack.clientWidth);
          const targetScroll = topicTrack.scrollLeft
            + activeRect.left
            - trackRect.left
            - ((topicTrack.clientWidth - activeRect.width) / 2);

          topicTrack.scrollTo({
            left: Math.max(0, Math.min(maxScroll, targetScroll)),
            behavior: 'auto'
          });

          updateTopicControls();
        });
      }
    }

    topicalLinks.forEach(link => {
      link.addEventListener('click', event => {
        const targetId = link.getAttribute('href');
        const target = targetId ? root.querySelector(targetId) : null;
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', targetId);
        }
      });
    });

    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.08,
          rootMargin: '0px 0px -45px'
        });

        reveals.forEach(element => observer.observe(element));
      } else {
        reveals.forEach(element => element.classList.add('is-revealed'));
      }
    }

    if (mobileBooking && hero) {
      let ticking = false;

      const updateMobileBooking = () => {
        ticking = false;
        const heroBottom = hero.getBoundingClientRect().bottom;
        const footer = document.querySelector('footer');
        const footerVisible = footer
          ? footer.getBoundingClientRect().top < window.innerHeight
          : false;

        mobileBooking.classList.toggle(
          'is-visible',
          heroBottom < 90 && !footerVisible
        );
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateMobileBooking);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      updateMobileBooking();
    }
  });
})();
